import { RegistryDiscount } from 'src/types/registryDiscount'
import dateformat from 'dateformat'
import css from './TermsAndConditions.styles.scss'

export const TermsAndConditions = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => {
  const {
    discountThresholdAmount,
    orderThresholdAmount,
    eligibilityEndsAt,
    eligibilityRegistryCreationMinDays,
    eligibleForMultiuseDiscount,
    isEligible,
  } = registryDiscount
  const expirationDate = dateformat(eligibilityEndsAt, 'UTC:mmm dS, yyyy')

  const multiUseDiscountDetails = `Apply on
    order value up to $${orderThresholdAmount}, for a max discount
    of $${discountThresholdAmount}. Registry must be active for ${eligibilityRegistryCreationMinDays} days.`

  const preEligibilityAndSingleUseDiscountDetails = `Registry must
    be active for ${eligibilityRegistryCreationMinDays} days.`

  const additionalDetails = isEligible
    ? eligibleForMultiuseDiscount
      ? multiUseDiscountDetails
      : preEligibilityAndSingleUseDiscountDetails
    : preEligibilityAndSingleUseDiscountDetails

  return (
    <div className={css.TermsAndConditions}>
      *Product exclusions apply and are subject to change. {additionalDetails}{' '}
      Expires {expirationDate}.
    </div>
  )
}
